import { Link } from "react-router-dom";

export function RegisterHelp() {
  return (
    <div className="px-5 mx-auto min-h-screen max-w-5xl">
      <div className="my-10">
        <Link
          to={"/help"}
          className="text-sm text-blue-500 underline flex mb-4"
        >
          Back To Help
        </Link>
        <h2 className="text-3xl font-bold">Register</h2>
      </div>

      <div className="flex flex-col gap-3">
        <div>You must use your email address to register into Expensehut.</div>

        <div className="text-red-500 text-sm">
          We do not support temporary email providers.
        </div>

        <p className="my-4">
          <strong className="flex mb-3">How to register?</strong>
          <ul style={{ listStyle: "number" }}>
            <li>
              Go to{" "}
              <a
                href="https://app.expensehut.com/register"
                target="_blank"
                rel="noreferrer"
                className="text-blue-500 underline"
              >
                Expense Tracker
              </a>{" "}
              and enter your email address.
            </li>
            <li>A verification link will be sent to your email address.</li>
            <li>
              Please check your spam box. You can re-send verificiation links
              upto 3 times.
            </li>
            <li>
              Incase if you are blocked, please email{" "}
              <strong>help@expensehut.com</strong>
            </li>
          </ul>
        </p>

        <br />
        <hr />
      </div>
    </div>
  );
}
